<template>
    <div class="body">
        <div class="columns is-vcentered">
            <div class="column">
                <img src="img/trust.jpg">
            </div>
            <div class="column is-three-fifths">
                <h1 class="title is-size-2 has-text-primary">Understanding the Trust Economy</h1>
                <p>The post-COVID world has revealed the fragility of old value chains and the weakness in ensuring clear and verifiable health security. The new Trust Economy as it has come to be known is based around the principle of ensuring that transactions, society, methods, and structures are resilient, sustainable, and health secure.</p>
                <p>The Trust Economy is built on the idea that we can only engage in meaningful relationships and transactions with parties with whom we trust. This is the start of new kinds of industries that will be more human-focused. This will fundamentally drive progress towards truly sustainable and inclusive industries.</p>
            </div>
        </div>

        <div class="columns is-variable is-8 is-vcentered">
            <div class="column">
                <p class="title">Rebuilding Customer Trust</p>
                <p>This figure is the big number of the post-COVID growth period since it highlights a significant and specific shift in customer preferences. There is a new high-level focus on health and ensuring that human interactions on any given value chain are proven to be health secure.</p>
            </div>
            <div class="column">
                <div class="highlightBox">
                    <p class="highlightText">83%</p>
                    <p class="subtitle">of customers that engage with businesses expect that there are adequate health security and disease monitoring measures in place</p>
                    <p class="is-size-7">(SMP&CO Partners Research, 2020)</p>
                </div>
            </div>
        </div>

        <div class="columns is-variable is-8 is-vcentered">
            <div class="column">
                <p class="title">Business Resiliency and Regulatory Compliance</p>
                <p>COVID-19 has shown the need to protect the human workers on the value chain since they drive productivity and growth. In this regard, SEQu-SUITE has developed solutions that allow businesses to get back to what they do best and keep doing business. Leave the regulatory compliance to SEQu-SUITE and the solutions we deploy, since they’re always kept up to spec and compliant. This is what keeps businesses resilient.</p>
            </div>
            <div class="column">
                <img src="img/dole.png">
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "TrustEconomy"
    }
</script>

<style scoped>
    .body {
        padding-left: 12%;
        padding-right: 12%;
        padding-top: 72px;
        padding-bottom: 72px;
    }

    .columns {
        margin-bottom: 78px;
    }

    .highlightBox {
        border: solid 1px #670DDB;
        padding: 24px;
    }

    .highlightText {
        color: #670DDB;
        font-size: 4.2em;
    }
</style>